const SINGLE_GRAPH_DURATION = ["1D", "7D", "14D", "30D"]

export { SINGLE_GRAPH_DURATION }
